import areIntlLocalesSupported from 'intl-locales-supported'

/**
 * The high order container for the invoice component
 *
 * @author  Pragya Gupta
 *
 */

let DateTimeFormat

/**
 * Use the native Intl.DateTimeFormat if available, or a polyfill if not.
 */
if (areIntlLocalesSupported(['fi'])) {
  DateTimeFormat = global.Intl.DateTimeFormat
} else {
  const IntlPolyfill = require('intl')
  DateTimeFormat = IntlPolyfill.DateTimeFormat
  Intl.NumberFormat = IntlPolyfill.NumberFormat // Some mobile didn't support this! So added to show currencies in pdf
  require('intl/locale-data/jsonp/fi')
}

export const formatFiToISO = (dateArray) => {
  const date = new Date(`${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`)
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}

export const formatFiDateToISO = (date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

export default DateTimeFormat

export const formatFiTimeToISO = (pickerDate) => {
  //let pickerOffset = pickerDate.getTimezoneOffset()
  let utcDate = new Date()
  //utcDate.setTime(pickerDate.getTime() - pickerOffset * 60000)
  utcDate.setTime(pickerDate.getTime())
  let utcTime = utcDate.toString()
  let found = utcTime.match(/\d\d:\d\d:\d\d/)
  return found[0]
}

export const timeDifference = (startDate, endDate) => {
  let date1 = new Date(startDate)
  let date2 = new Date(endDate)

  let diff = date2.getTime() - date1.getTime()
  let diffFullDays = Math.max(
    Math.floor((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24)),
    0
  )
  diff -= diffFullDays * 1000 * 60 * 60 * 24

  let hh = diff / 1000 / 60 / 60
  diff -= hh * 1000 * 60 * 60

  return Math.max(hh, 0)
}

export const isCurrentMonth = (date) => {
  if (typeof date === 'string') {
    const targetDate = new Date(date)
    const now = new Date()

    const isCurrentMonth = 
      targetDate.getFullYear() === now.getFullYear() &&
      targetDate.getMonth() === now.getMonth()

    return isCurrentMonth
  }

  return false
}
